import { Component, Input, OnDestroy, OnInit } from '@angular/core'
import { Subject } from 'rxjs'
import { first, takeUntil } from 'rxjs/operators'

import { EventLogAlertSubTypeEvent, EventLogSetting } from '@shared/modules/alerts/shared/event-log-setting.model'
import { AlertsService } from '@shared/modules/alerts/alerts.service'
import { AuthService } from '@app/modules/auth/auth.service'
import { User } from '@shared/models/user.model'

@Component({
  selector: 'lin-event-section',
  templateUrl: './event-section.component.html',
  styleUrls: ['./event-section.component.scss'],
  standalone: false,
})
export class EventSectionComponent implements OnInit, OnDestroy {
  eventLogSettings: EventLogSetting[]
  isLoaded = false
  user: User

  @Input() view: 'alert' | 'notification' = 'alert'

  private readonly onDestroy$ = new Subject<void>()

  constructor(
    private alertsService: AlertsService,
    private authService: AuthService,
  ) {}

  ngOnInit() {
    this.authService.currentUser$.pipe(first()).subscribe((user) => (this.user = user))
    this.alertsService
      .getEventLogSettings()
      .pipe(takeUntil(this.onDestroy$))
      .subscribe({
        next: (eventLogSettings) => {
          this.eventLogSettings = eventLogSettings
          this.isLoaded = true
        },
        error: () => {
          this.eventLogSettings = []
          this.isLoaded = true
        },
      })
  }

  getEventCount(event: EventLogAlertSubTypeEvent) {
    if (this.view !== 'notification') return

    const eventCount = `(${event.notificationCount})`
    return eventCount
  }

  getUrl(eventId: number) {
    if (this.user.isClient()) {
      const clientUrl =
        this.view === 'alert'
          ? `/client/alerts/events-log-details/events-log/${eventId}`
          : `/client/configuration/notifications-details/notifications`

      return clientUrl
    }

    const moduleName = this.user.isReseller() ? 'reseller' : 'admin'
    const adminUrl =
      this.view === 'alert'
        ? `/${moduleName}/alerts/events-log-details/events-log/${eventId}`
        : `/${moduleName}/config/notifications-details/notifications`

    return adminUrl
  }

  ngOnDestroy() {
    this.onDestroy$.next()
    this.onDestroy$.complete()
  }
}
